import { SubscriptionType } from "../../../types";
import AutoRenewTooltip from "../../AutoRenewTooltip/AutoRenewTooltip";

export const SubscriptionExpirationText: React.FC<{
  autoRenews: boolean;
  subscriptionType: SubscriptionType;
  expirationDate: Date;
  hasAppStoreSubscription?: boolean;
}> = ({ autoRenews, subscriptionType, expirationDate, hasAppStoreSubscription }) => {
  if (subscriptionType === SubscriptionType.Paddle && hasAppStoreSubscription) {
    return <>Starts on</>;
  }

  if (autoRenews) {
    return (
      <>
        <span>Auto-renews on </span>
        <AutoRenewTooltip
          isAutoRenewEnabled={autoRenews}
          expirationDate={expirationDate}
          type={subscriptionType}
        />
      </>
    );
  }

  return <>Expires on</>;
};
